<app-chat-card
  class="coming-soon-card"
  [header]="'Settings'"
  [description]="'Coming soon!'"
  [route]="'/chat'"
>
</app-chat-card>
